import { request } from "./ApiCommon";

function redeemCodeEndpoint(code: string, providerName: string) {
    return request("/api/v1/redeem-code/" + providerName + "?code=" + code, {
        method: "GET",
    })
}

export const redeemCodeApi = { redeemCodeEndpoint }
